import { fetcher } from '@commenda/utils';

export const upsertBillingPricingConfig = async (params: {
  monthlyPremiumBps: number;
  quarterlyPremiumBps: number;
}) => {
  const response = await fetcher('commenda-billing/catalog/config', {
    method: 'PUT',
    body: params,
  });

  return response;
};
